@for (tile of statefulTemplateArray; track tile) {
  <div [ngClass]="tile.name">
    {{ tile.value }}
  </div>
}
